import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import Fields from './Fields';
import { toast } from 'react-toastify';
import imageCompression from 'browser-image-compression';
import { newBadgeCategory } from 'services/badge.routes';
import { updateBadgeCategory } from 'services/badge.routes';

export default function NewBadgeCategory() {
    const [loading, setLoading] = useState(false);
    const [information, setInformation] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const method = searchParams.get("method");
    const { state } = useLocation();

    const schema = yup.object().shape({
        name: yup.string().required(),
        access_level: yup.string().required(),
        icon: yup.mixed().required(),
    });

    useEffect(() => {
        if (state) {
            setInformation({
                name: state.name,
                access_level: state.access_level,
            });
        }
    }, [state]);

    const handleBadgeChanges = async () => {
        if (state.id) {
            const formdata = await handleFormData(information);
            setLoading(true);
            updateBadgeCategory(state.id, formdata, (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    toast.error(data.message);
                } else {
                    toast.success("دسته بندی ویرایش شد!");
                    navigate(`/badge-category`);
                }
            });
        }
    };

    const handleFormData = async (info) => {
        let formdata = new FormData();
        const { icon, ...restInformation } = info;
        for (let item in restInformation) {
            if (restInformation[item]) formdata.append(item, restInformation[item]);
        }
        if (icon && icon.length > 0 && icon[0] instanceof File) {
            const compressedImage = await imageCompression(icon[0], { maxSizeMB: 2 });
            formdata.append("icon", compressedImage);
        }
        return formdata;
    };
    const handleNewBadgeCategory = () => {
        schema
            .validate(information)
            .then(async (res) => {
                if (res) {
                    const formdata = await handleFormData(information);
                    setLoading(true);
                    newBadgeCategory(formdata, (isOk, data) => {
                        setLoading(false);
                        if (!isOk) {
                            toast.error(data.message);
                        } else {
                            toast.success("دسته بندی جدید ایجاد شد!");
                            navigate(`/badge-category`);
                        }
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.errors[0]);
            });
    };
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />
            <p style={{ fontSize: 16, fontWeight: "bold" }}>{method !== "update" ? "دسته بندی جدید" : "ویرایش دسته بندی"}</p>
            <Fields information={information} handleUpdate={handleBadgeChanges} method={method} setInformation={setInformation} submit={handleNewBadgeCategory} />
        </DashboardLayout>
    )
}
